export default "__VITE_ASSET__71f2b18c__"